import { observable, computed, runInAction, action } from 'mobx';
import { post, get } from '../utils';
import { baseRequest } from '../operates';
import { toast } from '../components/notice';

// 优惠券相关
class SetParamsFetch {
    private route: string;
    private dataType: string = 'list'; // 默认数据方式为list
    private header: object;
    @observable public lists: any[] = []; // 数据列表集合
    @observable public data: any = {}; // 对象数据
    @observable public couponsUseData: any = { // 使用的优惠券
        templateIdCode: '',
        couponMoney: 0,
    };
    @observable public chooseCouponsIdCode: any = ''; // 优惠券选择 - ID
    @observable public chooseCouponsPrice: any = 0; // 优惠券选择 - 金额
    @observable public current: number = 0; // 优惠券tab切换

    constructor(url: any, dataType?: any, header?: any) {
        this.route = url;
        this.dataType = dataType || 'list';
        this.header = header || {};
    }

    async fetch(params: any, callBack?, errs?: any) {
        post(this.route, params).then((d) => {
            if (d.data) {
                let data: any = d.data;
                runInAction('fetchSuccess', () => {
                    if (this.dataType === 'list') {
                        this.lists = [];
                        data.list.forEach(item => {
                            item.isChecked = false;
                            item.userCouponRidCode === this.couponsUseData.templateIdCode && (item.isChecked = true);
                            this.lists.push(item);
                        });
                    } else {
                        this.data = data;
                    }
                    callBack && callBack(d);
                });
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    @computed
    get list() {
        return this.lists.slice();
    }

    @computed
    get dataObj() {
        return Object.assign({}, this.data);
    }

    // 选中优惠券
    @action('选中优惠券')
    public checkedItem(idCode: any): void {
        this.lists.map(item => {
            if (item.userCouponRidCode === idCode && item.isChecked) {
                this.chooseCouponsIdCode = 0;
                this.chooseCouponsPrice = 0;
                return item.isChecked = false;
            } else if (item.userCouponRidCode === idCode) {
                this.chooseCouponsIdCode = item.userCouponRidCode;
                this.chooseCouponsPrice = item.couponMoney;
                return item.isChecked = true;
                // return item.userCouponRidCode === idCode ? (item.isChecked = true) : (item.isChecked = false);
            } else {
                return item.isChecked = false;
            }
        });
    }

    // 使用优惠券
    @action('使用优惠券')
    public useCoupons(): void {
        this.couponsUseData = {
            templateIdCode: this.chooseCouponsIdCode,
            couponMoney: this.chooseCouponsPrice
        };
    }

    @action('领取优惠券')
    public receiveCoupon(params: any): void {
        baseRequest(params.url, params, (d, errCode, errDesc) => {
            if (errCode !== 200) {
                toast(errDesc);
                return false;
            }
            toast('领取成功');
            let coupons: any[] = this.data.coupons;
            let len: number = coupons.length;
            for (let i: number = 0; i < len; i++) {
                if (coupons[i].shareRidCode === params.shareRidCode) {
                    coupons[i].sharedCouponStatus = 2;
                    break;
                }
            }
        });
    }

    // 商品获取优惠券列表
    async couponsFetch(params: any, callBack?, errs?: any) {
        get(this.route, params).then((d) => {
            if (d.data) {
                let data: any = d.data;
                runInAction('couponsFetchSuccess', () => {
                    this.data = data;
                    callBack && callBack(d);
                });
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    // 商详优惠券领取
    @action('商详领取优惠券')
    public receiveCouponProduct(params: any): void {
        baseRequest(params.url, params, (d, errCode, errDesc) => {
            if (errCode === 20013) {
                toast(errDesc);
                let coupons: any[] = this.data.coupons;
                let len: number = coupons.length;
                for (let i: number = 0; i < len; i++) {
                    if (coupons[i].ruleDetailIdCode === params.ruleDetailId) {
                        coupons[i].receivedStatus = 3;
                        break;
                    }
                }
                return false;
            }
            if (errCode !== 200) {
                toast(errDesc);
                return false;
            }
            toast('领取成功，祝您购物愉快~');
            let coupons: any[] = this.data.coupons;
            let len: number = coupons.length;
            for (let i: number = 0; i < len; i++) {
                if (coupons[i].ruleDetailIdCode === params.ruleDetailId) {
                    coupons[i].receivedStatus = 2;
                    break;
                }
            }
        });
    }
}

export default SetParamsFetch;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/SetParamsFetch.ts